import { AController } from "@eagerlogic/react-mvc";
import { DashboardModel, VacationStatModel, UpcomingEventsModel, UpcomingEventItem } from "./DashboardModel";
import { UserVacationStatisticsData } from "data/UserVacationStatisticsData";
import { GetUserVacationCountResponse } from "rpc/UserVacationCountRpc";
import { ListResponse } from "rpc/UpcomingEventsRpc";
import { UpcomingEventsData } from "data/UpcomingEventsData";

export class DashboardController extends AController<DashboardModel> {

    private readonly statData = new UserVacationStatisticsData();
    private readonly upcomingEventsData = new UpcomingEventsData();

    protected createInitialModel(): DashboardModel {
        var res = new DashboardModel(true, null, null);

        this.rerender();

        return res;
    }

    public async rerender() {
        var statDto = await this.statData.getOrLoad();
        var eventsData = await this.upcomingEventsData.getOrLoad();
        var statModel = this.dtoToStatModel(statDto);
        var eventsModel = this.dataToUpcomingEventsModel(eventsData);

        this.render(new DashboardModel(false, statModel, eventsModel));
    }

    private dtoToStatModel(dto: GetUserVacationCountResponse): VacationStatModel {
        return new VacationStatModel(dto.annualVacationCount, dto.carriedVacationCount, dto.usedUpVacationCount, dto.remainingVacationCount);
    }

    private dataToUpcomingEventsModel(data: ListResponse) {
        var res = new UpcomingEventsModel();
        for (var item of data.items) {
            res.events.push(new UpcomingEventItem(item.icon, item.iconColor, item.title, item.date, item.description));
        }

        return res;
    }

}